import { Component } from '@angular/core';

@Component({
  selector: 'app-servicos',
  templateUrl: './servicos.component.html',
  styleUrls: ['./servicos.component.scss']
})
export class ServicosComponent {
  services = [
    {
      id: 'landing-pages',
      icon: 'fa-solid fa-rocket',
      image: 'assets/img/mister.png',
      title: 'Landing Pages',
      subtitle: 'Alta Conversão',
      description: 'Você tem segundos para convencer alguém a ficar no seu site. Uma landing page bem feita faz exatamente isso prende a atenção e transforma visitante em cliente.',
      features: [
        'Design focado em conversão',
        'Totalmente responsivo',
        'Integração com WhatsApp e formulários',
        'Otimização para SEO',
        'Entrega em até 7 dias'
      ],
      whatsappText: 'Olá!%20Gostaria%20de%20solicitar%20um%20orçamento%20para%20uma%20Landing%20Page.'
    },
    {
      id: 'sites-empresariais',
      icon: 'fa-solid fa-building',
      image: 'assets/img/login-j$a.png',
      title: 'Sites Empresariais',
      subtitle: 'Presença Digital Profissional',
      description: 'Seu cliente pesquisa no Google antes de comprar. Se você não aparece (ou aparece mal) ele vai pro concorrente. Um site profissional passa credibilidade e fecha negócios mesmo enquanto você dorme.',
      features: [
        'Design exclusivo e moderno',
        'Múltiplas páginas e seções',
        'Blog integrado (opcional)',
        'Painel de administração',
        'Certificado SSL incluso'
      ],
      whatsappText: 'Olá!%20Gostaria%20de%20solicitar%20um%20orçamento%20para%20um%20Site%20Empresarial.'
    },
    {
      id: 'lojas-virtuais',
      icon: 'fa-solid fa-cart-shopping',
      image: 'assets/img/meteora.png',
      title: 'Lojas Virtuais',
      subtitle: 'E-commerce Completo',
      description: 'Vender pelo Instagram tem limite. Uma loja virtual própria te dá controle total: do produto ao pagamento, sem depender de algoritmo nem pagar comissão pra plataforma.',
      features: [
        'Catálogo de produtos completo',
        'Checkout otimizado',
        'Integração com gateways de pagamento',
        'Gestão de estoque e pedidos',
        'Relatórios de vendas'
      ],
      whatsappText: 'Olá!%20Gostaria%20de%20solicitar%20um%20orçamento%20para%20uma%20Loja%20Virtual.'
    },
    {
      id: 'design-identidade',
      icon: 'fa-solid fa-palette',
      image: 'assets/img/academy.png',
      title: 'Design & Identidade Visual',
      subtitle: 'Marca que Impacta',
      description: 'Marca sem identidade é marca esquecida. Criamos do zero o visual da sua empresa, logo, cores, tipografia. Para que seu negócio seja reconhecido e lembrado onde quer que apareça.',
      features: [
        'Criação de logotipo',
        'Manual de identidade visual',
        'Paleta de cores e tipografia',
        'Artes para redes sociais',
        'Arquivos em todos os formatos'
      ],
      whatsappText: 'Olá!%20Gostaria%20de%20solicitar%20um%20orçamento%20para%20Design%20e%20Identidade%20Visual.'
    }
  ];
}
